import { IFormService } from "../../service/form/FormService";

export default class GetBoFormVersionsInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formReportingPeriodId: number) {
    return this.formService.getBoFormVersions(formReportingPeriodId);
  }
}
